import React from 'react';
import { useTranslate } from 'react-admin';
import { Box, Card, CardContent, Typography } from '@mui/material';

export const TestList: React.FC = () => {
  const translate = useTranslate();
  return (
    <Box sx={{ p: 3 }}>
      <Card>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            {translate('resources.test.name', { smart_count: 2 })}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {translate('common.coming_soon')}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default TestList;
